import { render, staticRenderFns } from "./CarouselTireImage.vue?vue&type=template&id=93db7aec"
import script from "./CarouselTireImage.vue?vue&type=script&lang=ts"
export * from "./CarouselTireImage.vue?vue&type=script&lang=ts"
import style0 from "./CarouselTireImage.vue?vue&type=style&index=0&id=93db7aec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports